const BOOKING_REQUEST_ID_HEADER = 'x-booking-request-id'
const API_KEY_HEADER = 'x-Api-Key'
const REQUEST_ID_HEADER = 'x-Request-Id'
const AUTH_TOKEN_HEADER = 'x-auth-token'
const AUTHORIZATION_HEADER = 'Authorization'
const CLIENT_USER_AGENT_HEADER = 'X-Client-User-Agent'
const VCLID_HEADER = 'X-Vclid'
const SAPI_VARIATIONS_HEADER = 'x-sapi-variations'

type PrepareBoVioHeadersProps = {
  profileKey: string
  clientUserAgent: string
  httpRequestId?: string
  bookingRequestId?: string
  authToken?: string
  otpToken?: string
  vclid?: string
  sapiVariations?: string
}

/**
 * Composes headers property for all BoVio requests
 * @param params - Parameters object
 * @param params.profileKey - [Mandatory] The BoVio profile key used for experiments
 * @param params.clientUserAgent - [Mandatory] Concatenated string with "appName/appVersion" format for tracking purposes
 * @param params.httpRequestId - [Optional] The shared id for a payment session requests
 * @param params.bookingRequestId - [Optional] The booking id for requests following booking creation
 * @param params.authToken - [Optional] The cognito auth token used for requests that need auth
 * @param params.otpToken - [Optional] The short-lived OTP access token, sent on its own Authorization header so it never collides with authToken
 * @param params.vclid - [Optional] vclid cookie used for booking creation
 * @param params.sapiVariations - [Optional] Combination of sapi experiments forwarded to BoVio
 */
export const prepareBoVioHeaders = ({
  profileKey,
  clientUserAgent,
  httpRequestId,
  bookingRequestId,
  authToken,
  otpToken,
  vclid,
  sapiVariations
}: PrepareBoVioHeadersProps) => ({
  Accept: 'application/json',
  [API_KEY_HEADER]: profileKey,
  [CLIENT_USER_AGENT_HEADER]: clientUserAgent,
  ...(httpRequestId ? {[REQUEST_ID_HEADER]: httpRequestId} : {}),
  ...(bookingRequestId ? {[BOOKING_REQUEST_ID_HEADER]: bookingRequestId} : {}),
  ...(authToken ? {[AUTH_TOKEN_HEADER]: authToken} : {}),
  ...(otpToken ? {[AUTHORIZATION_HEADER]: `Bearer ${otpToken}`} : {}),
  ...(vclid ? {[VCLID_HEADER]: vclid} : {}),
  ...(sapiVariations ? {[SAPI_VARIATIONS_HEADER]: sapiVariations} : {})
})
